import type { IFundMethodValue, IUpdateProjectGridRowFundDataProps } from './thunkTypes';

export function isParentFundDataMethod(
  field: IUpdateProjectGridRowFundDataProps['field'],
  value: IUpdateProjectGridRowFundDataProps['value']
): value is IFundMethodValue {
  return field === 'fundMethod' && typeof value === 'string' && value.includes('-parent');
}
